/* ec-sec-static-header.js — logic externalized verbatim from sections/static-header.liquid (no Liquid values used) */
(function() {
  if (window.__ecAsset_staticHeader) return;
  window.__ecAsset_staticHeader = 1;

  var wrapper, toggle, drawer, overlay, searchToggle, searchForm;

  function onScroll() {
    if (!wrapper) return;
    if (window.scrollY > 10) {
      wrapper.classList.add('is-scrolled');
    } else {
      wrapper.classList.remove('is-scrolled');
    }
  }

  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) toggleMenu();
    if (searchForm && searchForm.classList.contains('is-open')) closeSearch();
  }

  function toggleMenu() {
    if (!drawer) return;
    var isOpen = drawer.classList.contains('is-open');
    if (isOpen) {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      if (toggle) {
        toggle.classList.remove('is-active');
        toggle.setAttribute('aria-expanded', 'false');
      }
      document.body.style.overflow = '';
      if (typeof EC !== 'undefined' && EC.releaseFocus) EC.releaseFocus();
    } else {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      if (toggle) {
        toggle.classList.add('is-active');
        toggle.setAttribute('aria-expanded', 'true');
      }
      document.body.style.overflow = 'hidden';
      if (typeof EC !== 'undefined' && EC.trapFocus) EC.trapFocus(drawer);
    }
  }

  function onDrawerNavClick(e) {
    var link = e.target.closest('.ec-mobile-link--has-sub');
    if (!link) return;
    e.preventDefault();
    var sub = link.nextElementSibling;
    var icon = link.querySelector('svg');
    if (sub) {
      sub.classList.toggle('is-open');
      var isOpen = sub.classList.contains('is-open');
      link.setAttribute('aria-expanded', String(isOpen));
      if (icon) {
        icon.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
      }
    }
  }

  function openSearch() {
    if (!searchForm) return;
    searchForm.classList.add('is-open');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    var inp = searchForm.querySelector('input[type="search"]');
    if (inp) inp.focus();
  }

  function closeSearch() {
    if (!searchForm) return;
    searchForm.classList.remove('is-open');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
  }

  function onSearchToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    if (searchForm && searchForm.classList.contains('is-open')) closeSearch();
    else openSearch();
  }

  function onDocClick(e) {
    if (!searchForm || !searchForm.classList.contains('is-open')) return;
    if (searchForm.contains(e.target)) return;
    if (searchToggle && searchToggle.contains(e.target)) return;
    closeSearch();
  }

  function init() {
    wrapper = document.getElementById('ec-header-wrapper');
    toggle = document.getElementById('ec-menu-toggle');
    drawer = document.getElementById('ec-mobile-drawer');
    overlay = document.getElementById('ec-drawer-overlay');

    window.removeEventListener('scroll', onScroll);
    if (wrapper) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    document.removeEventListener('keydown', onKeydown);
    document.addEventListener('keydown', onKeydown);

    if (toggle) toggle.addEventListener('click', toggleMenu);
    if (overlay) overlay.addEventListener('click', toggleMenu);

    var drawerClose = document.getElementById('ec-drawer-close');
    if (drawerClose) {
      drawerClose.removeEventListener('click', toggleMenu);
      drawerClose.addEventListener('click', toggleMenu);
    }

    /* Submenu toggle via event delegation */
    var drawerNav = drawer ? drawer.querySelector('.ec-drawer-nav') : null;
    if (drawerNav) {
      drawerNav.removeEventListener('click', onDrawerNavClick);
      drawerNav.addEventListener('click', onDrawerNavClick);
    }

    searchToggle = document.getElementById('ec-search-toggle');
    searchForm = document.getElementById('ec-header-search');
    if (searchToggle) {
      searchToggle.removeEventListener('click', onSearchToggle);
      searchToggle.addEventListener('click', onSearchToggle);
    }
    document.removeEventListener('click', onDocClick);
    document.addEventListener('click', onDocClick);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
